import type { Distance, Pixel } from "@pdfking/math"
import type { HorizontalAlign } from "../align/HorizontalAlign"
import type { VerticalAlign } from "../align/VerticalAlign"
import type { BlobMap } from "./BlobMap"
import type { ColorMap } from "./ColorMap"
import type { ScaleMap } from "./ScaleMap"

export type PlottingContext = Partial<{
  readonly color_map: ColorMap
  readonly file_map: BlobMap
  readonly font_family: string
  readonly font_size: Pixel
  readonly horizontal_align: HorizontalAlign
  readonly image_resolution: Pixel
  readonly page_bleed: Distance
  readonly scale_bleed: Distance
  readonly scale_map: ScaleMap
  readonly stroke_width: Distance
  readonly unit_to_px: number
  readonly vertical_align: VerticalAlign
}>
